import { forwardRef } from 'react'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, List, ListItem, ListItemText, Slide, IconButton } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTrash, faReply, faTimes } from '@fortawesome/free-solid-svg-icons'

const Transition = forwardRef(function Transition (props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const BulkActionDialog = ({ open, onClose, onConfirm, reports, onRemoveReport, actionType }) => {
    let title = ''
    let description = ''
    let icon = faCheckCircle
    let iconColor = '#4caf50'
    let confirmLabel = ''
    let confirmColor = 'primary' // 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'

    const count = reports.length

    if (actionType === 'autoasignar') {
        title = 'Tomar Pautas (Auto-asignación)'
        description = `Está a punto de asignarse las siguientes ${count} pautas. Aparecerán en su lista de "Pautas preparadas".`
        icon = faCheckCircle
        iconColor = '#4caf50'
        confirmLabel = 'Tomar Pautas'
        confirmColor = 'primary'
    } else if (actionType === 'eliminar') {
        title = 'Eliminar Órdenes de Trabajo'
        description = `Está a punto de eliminar las siguientes ${count} pautas. Esta acción no se puede deshacer.`
        icon = faTrash
        iconColor = '#f44336'
        confirmLabel = 'Eliminar'
        confirmColor = 'error'
    } else if (actionType === 'mover') {
        // Filter only those that are in state 'Asignar' to display in the list of what will move
        const movingCount = reports.filter(r => r.state === 'Asignar' || r.estado === 'Asignar').length
        title = 'Mover Órdenes de Trabajo a Origen'
        description = `Está a punto de mover ${movingCount} de las ${count} pautas seleccionadas al estado "Origen". Las restantes serán ignoradas.`
        icon = faReply
        iconColor = '#ff9800'
        confirmLabel = 'Mover a Origen'
        confirmColor = 'warning'
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle style={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" gutterBottom style={{ marginBottom: 15 }}>
                    {description}
                </Typography>
                <List dense style={{ maxHeight: '250px', overflowY: 'auto', backgroundColor: '#f9f9f9', borderRadius: 8, padding: 8 }}>
                    {reports.map((report) => {
                        const isAsignar = report.state === 'Asignar' || report.estado === 'Asignar'
                        const isMoverType = actionType === 'mover'
                        const itemOpacity = isMoverType && !isAsignar ? 0.5 : 1

                        return (
                            <ListItem
                                key={report._id}
                                style={{
                                    opacity: itemOpacity,
                                    borderBottom: '1px solid #eee'
                                }}
                                secondaryAction={
                                    onRemoveReport && (
                                        <IconButton edge="end" aria-label="remove" onClick={() => onRemoveReport(report._id)}>
                                            <FontAwesomeIcon icon={faTimes} style={{ color: '#f44336', fontSize: 14 }} />
                                        </IconButton>
                                    )
                                }
                            >
                                <div style={{ marginRight: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', width: 20 }}>
                                    <FontAwesomeIcon
                                        icon={isMoverType && !isAsignar ? faReply : icon}
                                        style={{
                                            color: isMoverType && !isAsignar ? '#ccc' : iconColor,
                                            fontSize: 16
                                        }}
                                    />
                                </div>
                                <ListItemText
                                    primary={`OT: ${report.newIdIndex || report.idIndex || 'S/I'} - ${report.maquina?.equ || report.machine || 'S/I'} - [${report.state && report.origen === true ? 'Origen' : (report.estado || report.state || 'S/I')}]`}
                                    secondary={report.guide || ''}
                                    primaryTypographyProps={{ style: { fontSize: 13, fontWeight: 'medium' } }}
                                    secondaryTypographyProps={{ style: { fontSize: 11, width: '80%' } }}
                                />
                            </ListItem>
                        )
                    })}
                </List>
            </DialogContent>
            <DialogActions style={{ padding: '12px 24px' }}>
                <Button onClick={onClose} color="inherit" variant="outlined" style={{ marginRight: 8 }}>
                    Cancelar
                </Button>
                <Button
                    onClick={() => onConfirm('delete')}
                    color={confirmColor}
                    variant="contained"
                    disabled={count === 0}
                    startIcon={<FontAwesomeIcon icon={icon} />}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default BulkActionDialog
